import { render, staticRenderFns } from "./applyResultNx.vue?vue&type=template&id=71e5d519&scoped=true&"
import script from "./applyResultNx.vue?vue&type=script&lang=js&"
export * from "./applyResultNx.vue?vue&type=script&lang=js&"
import style0 from "./applyResultNx.vue?vue&type=style&index=0&id=71e5d519&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e5d519",
  null
  
)

export default component.exports